"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebouncedCallback = useDebouncedCallback;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
// Taken from https://stackoverflow.com/a/57335271/1936629
function useDebouncedCallback(callback, wait) {
  // track args & timeout handle between calls
  var argsRef = (0, _react.useRef)();
  var timeout = (0, _react.useRef)();
  var cleanup = (0, _react.useCallback)(function () {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }, []);

  // make sure our timeout gets cleared if
  // our consuming component gets unmounted
  (0, _react.useEffect)(function () {
    return cleanup;
  }, [cleanup]);
  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // capture latest args
    argsRef.current = args;

    // clear debounce timer
    cleanup();

    // start waiting again
    timeout.current = setTimeout(function () {
      if (argsRef.current) {
        callback.apply(void 0, (0, _toConsumableArray2["default"])(argsRef.current));
      }
    }, wait);
  }, [callback, cleanup, wait]);
}
//# sourceMappingURL=useDebouncedCallback.js.map